export default {"src":"/_next/static/media/sports-kabaddi-sharp.cb44ef58.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};